import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button, Label,
    Spinner,
    Progress,
    Table
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import { AvForm, AvField, AvGroup, AvCheckboxGroup, AvCheckbox, AvInput } from "availity-reactstrap-validation"

import { Redirect } from "react-router-dom"

import apiResponse from '../../../../services/apiResponse'
import { cancelToken } from '../../../../services/adapters/kepegawaian/menuService'

import DetailBloc from '../Detail/Blocs/DetailBloc'

class DetailView extends Component {
    detailBloc = new DetailBloc()
    
    source

    constructor(props) {
        super(props)
        this.state = {
            menuList: [],
            detail: [],
            detailAccess: [],
            dataForm: {},
            isLoading: 0 
        }
    }

    loadMenu = async () => {
        const query = {}
        await this.detailBloc.fetchMenu(query, this.source.token)
    }

    loadDetail = async () => {
        const query = {
            id: this.props.id
        }
        await this.detailBloc.fetchDetail(query, this.source.token)
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadMenu().then(() => {
            this.loadDetail()
        })
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    componentDidMount() {
        this.setTokenAPI()

        this.detailBloc.menuChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL: 
                    this.setState({ isLoading: 25 })
                    break
                case apiResponse.LOADING:
                    this.setState({ isLoading: 50 })
                    break
                case apiResponse.COMPLETED:
                    this.setState({ isLoading: 100 })
                    setTimeout(() => {
                        this.setState({ menuList: result.data.response })
                    }, 800);
                    break
                case apiResponse.ERROR:
                    this.setState({ isLoading: 100 })
                    break
                default:
                    break
            }
        })

        this.detailBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL:
                    break
                case apiResponse.LOADING:
                    break
                case apiResponse.COMPLETED:
                    const res = result.data.response
                    this.setState({ detail: res.akses, detailAccess: res.detail })
                    break
                case apiResponse.ERROR:
                    break
                default:
                    break
            }
        })

    }

    componentWillUnmount() {
        this.detailBloc.detailChannel.unsubscribe()
        this.detailBloc.menuChannel.unsubscribe()
    }

    render() {
        let count = -1;
        return (
            <Fragment>
                <Container fluid>
                    <Card>
                        <CardBody>
                            <CardTitle>Detail Hak Akses</CardTitle>
                            <hr/>
                            <AvForm
                                className="needs-validation"
                                onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                            >
                                <AvField name={`access_id`} value={this.props.id} type="hidden" />
                                <Row mb="3">
                                    <Col md="6">
                                        <AvGroup>
                                            <Label htmlFor="fieldAccessCode">Kode Akses</Label>
                                            <AvField
                                                name="access_code"
                                                placeholder="Kode Akses..."
                                                type="text"
                                                className="form-control"
                                                id="fieldAccessCode"
                                                value={this.state.detail?.access_code}
                                                readOnly
                                            />
                                        </AvGroup>
                                    </Col>

                                    <Col md="6">
                                        <AvGroup>
                                            <Label htmlFor="fieldAccessName">Name Akses</Label>
                                            <AvField
                                                name="access_name"
                                                placeholder="Nama Akses..."
                                                type="text"
                                                className="form-control"
                                                id="fieldAccessName"
                                                value={this.state.detail?.access_name}
                                                readOnly
                                            />
                                        </AvGroup>
                                    </Col>

                                    {/* Menu Disini */}
                                    { this.state.menuList?.result ?
                                        <Col md="12">
                                            <Table>
                                                <thead>
                                                    <tr>
                                                        <th>No</th>
                                                        <th>Nama Menu</th>
                                                        <th>Read</th>
                                                        <th>Create</th>
                                                        <th>Update</th>
                                                        <th>Delete</th>
                                                        <th>Approve</th>
                                                        <th>Print</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.state.menuList?.result.map((value, index) => {
                                                        let obj = this.state.detailAccess?.find(o => o.access_detail_menu_id === value.menu_id);
                                                        const isHaveChild = (value.childs.length > 0);
                                                        const childs = isHaveChild && value.childs
                                                        count++;
                                                        return (
                                                            <Fragment key={index}>
                                                                <tr>
                                                                    <td>{count + 1}</td>
                                                                    <td>
                                                                        <Label>{value.menu_name}</Label>
                                                                        <AvField name={`menuId[${count}]`} value={value.menu_id} type="hidden" />
                                                                    </td>
                                                                    <td>
                                                                        <AvInput type="checkbox" name={`isRead[${count}]`} defaultChecked={obj?.access_detail_read} disabled />
                                                                    </td>
                                                                    <td>
                                                                        <AvInput type="checkbox" name={`isCreate[${count}]`} defaultChecked={obj?.access_detail_create} disabled />
                                                                    </td>
                                                                    <td>
                                                                        <AvInput type="checkbox" name={`isUpdate[${count}]`} defaultChecked={obj?.access_detail_update} disabled />
                                                                    </td>
                                                                    <td>
                                                                        <AvInput type="checkbox" name={`isDelete[${count}]`} defaultChecked={obj?.access_detail_delete} disabled />
                                                                    </td>
                                                                    <td>
                                                                        <AvInput type="checkbox" name={`isApprove[${count}]`} defaultChecked={obj?.access_detail_approve} disabled />
                                                                    </td>
                                                                    <td>
                                                                        <AvInput type="checkbox" name={`isPrint[${count}]`} defaultChecked={obj?.access_detail_print} disabled />
                                                                    </td>
                                                                </tr>
                                                                { isHaveChild &&
                                                                    childs.map(( child, i ) => {
                                                                        let obj = this.state.detailAccess?.find(o => o.access_detail_menu_id === child.menu_id);
                                                                        count++;
                                                                        return (
                                                                            <tr key={i}>
                                                                                <td>{count + 1}</td>
                                                                                <td>
                                                                                    <Label style={{ marginLeft: '30px' }}>{child.menu_name}</Label>
                                                                                    <AvField name={`menuId[${count}]`} value={child.menu_id} type="hidden" />
                                                                                </td>
                                                                                <td>
                                                                                    <AvInput type="checkbox" name={`isRead[${count}]`} defaultChecked={obj?.access_detail_read} disabled />
                                                                                </td>
                                                                                <td>
                                                                                    <AvInput type="checkbox" name={`isCreate[${count}]`} defaultChecked={obj?.access_detail_create} disabled />
                                                                                </td>
                                                                                <td>
                                                                                    <AvInput type="checkbox" name={`isUpdate[${count}]`} defaultChecked={obj?.access_detail_update} disabled />
                                                                                </td>
                                                                                <td>
                                                                                    <AvInput type="checkbox" name={`isDelete[${count}]`} defaultChecked={obj?.access_detail_delete} disabled />
                                                                                </td>
                                                                                <td>
                                                                                    <AvInput type="checkbox" name={`isApprove[${count}]`} defaultChecked={obj?.access_detail_approve} disabled />
                                                                                </td>
                                                                                <td>
                                                                                    <AvInput type="checkbox" name={`isPrint[${count}]`} defaultChecked={obj?.access_detail_print} disabled />
                                                                                </td>
                                                                            </tr>
                                                                        )
                                                                    })
                                                                }
                                                            </Fragment>
                                                        )
                                                    })}
                                                </tbody>
                                            </Table>

                                        </Col>
                                        :
                                        <Col md="12" style={{ marginTop: 12 }}>
                                            <Progress value={this.state.isLoading} />
                                        </Col>
                                    }

                                </Row>
                            </AvForm>
                        </CardBody>
                    </Card>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin data tersebut sudah benar?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to='/setting/accesses.html'/>
                : null }
            </Fragment>
        )
    }
}

export default DetailView